import ApiService from "./api.service";
import UtilService from "./util.service";

const BULK_PAYOUT_BATCH_BASE_PATH = "/api/bulkPayoutBatches";

const BulkPayoutBatchService = {
  search(filters, options = {}, expand = []) {
    const params = UtilService.buildPaginationParams(options);
    expand.forEach(value => params.append("expand", value));
    return ApiService.post(`${BULK_PAYOUT_BATCH_BASE_PATH}/search?${params.toString()}`, filters || {});
  },

  getHeaders(batchId) {
    return ApiService.get(`${BULK_PAYOUT_BATCH_BASE_PATH}/${batchId}/headers`);
  },

  getErrors(batchId, options = {}) {
    const params = UtilService.buildPaginationParams(options);
    return ApiService.get(`${BULK_PAYOUT_BATCH_BASE_PATH}/${batchId}/errors?${params.toString()}`);
  }
};

export default BulkPayoutBatchService;
